"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _EscrowDescription = require("./EscrowDescription");
Object.keys(_EscrowDescription).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _EscrowDescription[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _EscrowDescription[key];
    }
  });
});